let options = window.checkoutOptions;
let elms = {};
let selectors = [
    '#payment-form',
    '#g-token',
    '#checkout__card-saved',
    '#checkout__card-container',
    '#checkout__paypal-desc',
    '#checkout__gpay',
    '#total-amount__price',
    '#checkout__submit',
    '#PaymentForm_packet',
    '#payment-form__payment-type-title',
    '#checkout__content-pack-packets',
    '#total-amount__price',
    '#packet-block',
    '.choose-pack',
    '.choose-pack__button',
    '.choose-pack__button-select',
    '.credit-card-group',
    '.card-number',
    '.card-expiration',
    '.card-cvv',
    '.card-wrapper',
    '#tot-ttl',
    '#tot-amt',
];

let sending = false;

const baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
};

const allowedCardNetworks = ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'];

const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];

const tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
        'gateway': 'stripe',
        'stripe:version': '2024-06-20',
        'stripe:publishableKey': options['stripeKey'],
    },
};

const baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
        allowedAuthMethods: allowedCardAuthMethods,
        allowedCardNetworks: allowedCardNetworks,
    },
};

const cardPaymentMethod = Object.assign(
    {},
    baseCardPaymentMethod,
    {
        tokenizationSpecification: tokenizationSpecification,
    },
);

let paymentsClient = null;

function getGoogleIsReadyToPayRequest() {
    return Object.assign(
        {},
        baseRequest,
        {
            allowedPaymentMethods: [baseCardPaymentMethod],
        },
    );
}

function getGooglePaymentDataRequest() {
    const paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    paymentDataRequest.merchantInfo = {
        merchantId: options['merchantId'],
        merchantName: 'Autoinspect.us LLC',
    };

    console.log(options['merchantId']);

    paymentDataRequest.callbackIntents = ['PAYMENT_AUTHORIZATION'];

    return paymentDataRequest;
}

function getGooglePaymentsClient() {
    if (paymentsClient === null) {
        paymentsClient = new google.payments.api.PaymentsClient({
            environment: options['gpayMode'],
            paymentDataCallbacks: {
                onPaymentAuthorized: onPaymentAuthorized,
            },
        });
    }
    return paymentsClient;
}

function onPaymentAuthorized(paymentData) {
    return new Promise(function (resolve, reject) {
        // handle the response
        processPayment(paymentData).then(function (token) {
            document.dispatchEvent(
                new CustomEvent('googlePay:complete', {detail: {'token': token}}));
            resolve({transactionState: 'SUCCESS'});
        }).catch(function (e) {
            resolve({
                transactionState: 'ERROR',
                error: {
                    intent: 'PAYMENT_AUTHORIZATION',
                    message: '',
                    reason: '',
                },
            });
        });
    });
}

function googleReady() {
    const paymentsClient = getGooglePaymentsClient();
    paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest()).then(function (response) {
        if (response.result) {
            addGooglePayButton();
        }
    }).catch(function (err) {
        console.error(err);
    });
}

function addGooglePayButton() {
    const paymentsClient = getGooglePaymentsClient();
    const button =
        paymentsClient.createButton({onClick: onGooglePaymentButtonClicked});
    document.getElementById('google-pay-btn').appendChild(button);
}

function getGoogleTransactionInfo() {
    let total = $('#pay-amount').val();

    return {
        countryCode: 'US',
        currencyCode: 'USD',
        totalPriceStatus: 'FINAL',
        // set to cart total
        totalPrice: total.toString(),
    };
}

function onGooglePaymentButtonClicked() {
    if (!validateData()) {
        return;
    }
    const paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();

    const paymentsClient = getGooglePaymentsClient();
    paymentsClient.loadPaymentData(paymentDataRequest);
}

function processPayment(paymentData) {
    return new Promise(function (resolve, reject) {
        console.log(paymentData);
        let paymentToken = JSON.parse(
            paymentData.paymentMethodData.tokenizationData.token);
        resolve(paymentToken.id);
    });
}

function stripeReady() {
    window.stripe = Stripe(options['stripeKey'], {locale: window.appLocale || 'en'});

    let elements = stripe.elements();

    let style = {
        base: {
            color: '#32325d',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
                color: '#777',
                fontSize: '15px',
            },
        },
        invalid: {
            color: '#e3342f',
            iconColor: '#e3342f',
        },
    };

    window.card = elements.create('card', {style: style, hidePostalCode: true});

    window.card.mount('#card-element');

    window.card.addEventListener('change', function (event) {
        let displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });

    let agree = document.getElementById('agree');
    agree.onclick = () => agree.classList.remove('is-invalid');

    let email = document.getElementById('email');
    email.onkeydown = () => email.classList.remove('is-invalid');

    document.getElementById('pay-btn').addEventListener('click', function (e) {
        prepareData();
    });

    let form = document.getElementById('payment-form');

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        return false;
    });

    document.addEventListener('googlePay:complete', (event) => {
        startSending();
        console.log(event.detail.token);
        submitData(event.detail.token, 'google');
    });
}

function startSending() {
    $('#page-preloader').show();
    $('.pay-btn').removeClass('btn-r').addClass('disabled');
    sending = true;
}

function finishSending(delay) {
    $('#page-preloader').fadeOut(delay || 0);
    $('.pay-btn').removeClass('disabled').addClass('btn-r');
    sending = false;
}

function validateData() {
    let valid = true;

    let email = document.getElementById('email');
    if (!validateEmail(email.value)) {
        email.classList.add('is-invalid');
        valid = false;
        email.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        })
    }

    let agree = document.getElementById('agree');

    if (!agree.checked) {
        agree.classList.add('is-invalid');
        valid = false;
        agree.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        })
    }

    return valid;
}

function validateEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.trim());
}

function prepareData() {
    let payType = document.getElementById('pay-type').value;
    if (sending || payType === 'google') {
        return;
    }

    if (!validateData()) {
        return;
    }

    startSending();

    let errorElement = document.getElementById('card-errors');
    errorElement.textContent = '';
    errorElement.innerHTML = '';

    hideError();

    if (document.getElementById('pay-type').value === 'paypal') {
        submitData();
        return;
    }

    window.stripe.createPaymentMethod({
        type: 'card',
        card: window.card,
        billing_details: {
            // email: email.value,
        },
    }).then(({paymentMethod, error}) => {
        if (error) {
            finishSending();
            errorElement.textContent = error.message;
            document.getElementById('card-data').scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
        } else {
            console.log(paymentMethod);
            submitData(paymentMethod.id);
        }
    });
}

function showError() {
    $('#payment-fail').show();
}

function hideError() {
    $('#payment-fail').hide();
}

const confirmPaymentMethod = (secret, pm, pi) => {
    stripe.confirmCardPayment(
        secret, {
            payment_method: pm
        }
    ).then(result => {
        document.getElementById('confirm-overlay').classList.remove('show');
        if (result.error) {
            showError(result.error.message);
            finishSending(300);
        } else {
            submitData(pm, '', pi);
        }
    })
}

function submitData(token = '', type = '', intent = null) {
    let redirect = false;
    let popup = false;
    let formData = $('#payment-form').serializeArray();
    const pType = type || document.getElementById('pay-type').value;
    formData.push({name: 'type', value: pType});
    formData.push({name: 'token', value: token});
    intent && formData.push({name: 'intent', value: intent});
    $('.invalid-feedback').children('strong').text('');
    $('#payment-form').find('input').removeClass('is-invalid');
    $.ajax({
        method: 'POST',
        headers: {Accept: 'application/json'},
        url: options['payUrl'],
        data: formData,
        success: response => {
            if (response.success) {
                redirect = response.redirect || false;
                popup = response.popup || false;
                if (popup) {
                    document.getElementById('confirm-overlay').classList.add('show');
                    confirmPaymentMethod(response.secret, response.pm, response.pi)
                    return;
                }
                if (redirect) {
                    document.location.href = redirect;
                    return;
                }
            }
            if (response.errors) {
                Object.keys(response.errors).forEach(function (key) {
                    $('#' + key).addClass('is-invalid');
                    $('#' + key + 'Error').children('strong').text(response.errors[key]);
                });
                return;
            }
            showError();
        },
        error: response => console.log(response),
        complete: () => !redirect && !popup && finishSending(300)
    });
}

function loadJs() {
    const script1 = document.createElement('script');
    script1.src = 'https://js.stripe.com/v3/';
    script1.onload = stripeReady
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = 'https://pay.google.com/gp/p/js/pay.js';
    script2.onload = googleReady
    document.body.appendChild(script2);
}

function setElements() {
    $.each(selectors, function (i, selector) {
        var prop = selector.replace(/#|\./g, '');
        elms[prop] = $(selector);
    });
}

function setElementsEvents() {
    $('input[name="p-type"]').on('change', function () {
        setType($(this));
    });

    elms['choose-pack__button'].on('click', function (e) {
        e.preventDefault();
        setActivePacket($(this));
    });

    elms['choose-pack'].on('click', function (e) {
        e.preventDefault();
        setActivePacket($(this).find('.choose-pack__button'));
    });

    elms['choose-pack__button-select'].on('click', function (e) {
        e.preventDefault();
        setActivePacket($(this));
    });
}

function setType(el) {
    hideError();
    elms['checkout__google-pay'] = $('#checkout__google-pay');

    if (typeof el === 'undefined') {
        el = $('input[name="p-type"]:checked');
    }
    console.log(el.val());
    $('#pay-type').val(el.val())
    //hide all btn
    $('.pay-btn').hide();
    switch (el.val()) {
        case 'paypal':
            elms['checkout__card-container'].hide();
            elms['checkout__card-saved'].hide();
            elms['checkout__google-pay'].hide();
            elms['checkout__paypal-desc'].show();
            $('.pp-pay').css('display', 'flex');
            break;
        case 'card':
            elms['checkout__paypal-desc'].hide();
            elms['checkout__card-saved'].hide();
            elms['checkout__google-pay'].hide();
            elms['checkout__card-container'].show();
            $('.cc-pay').show();
            break;
        case 'google':
            elms['checkout__paypal-desc'].hide();
            elms['checkout__card-saved'].hide();
            elms['checkout__card-container'].hide();
            elms['checkout__google-pay'].show();
            $('.gp-pay').show();
            break;
        case 'saved_cards':
            elms['checkout__google-pay'].hide();
            elms['checkout__paypal-desc'].hide();
            elms['checkout__card-container'].hide();
            elms['checkout__card-saved'].show();
            break;
    }
}

function setActivePacket(el) {
    elms['choose-pack'].each(function (index, b) {
        b = $(b);
        b.removeClass('select_active');


        b.find('.choose-pack__button')
            .attr('class', 'choose-pack__button')
            .html(options['Select']);
    });

    el.parent('.choose-pack').addClass('select_active');

    let tot = el.parent('.choose-pack').data('amount');

    el.attr('class', 'choose-pack__button')
        .html('<span class="choose-pack__button-selected-select-btn"></span> ' + options['Selected']);

    elms['total-amount__price'] = $('.total-amount__price__span')
    elms['total-amount__price'].text(tot);

    elms['tot-ttl'].text(el.parent('.choose-pack').data('title'));
    elms['tot-amt'].text(tot);

    //Scroll to payment form
    if (elms['checkout__content-pack-packets'].length) {
        $('body,html').animate({scrollTop: elms['checkout__content-pack-packets'].offset().top - 65});
    }
    $('#packet-id').val(el.parent('.choose-pack').data('id'));

    $('#pay-amount').val(tot);
}

loadJs();

$(function () {
    setElements();
    setElementsEvents();

    $(window).scroll(function () {
        if (!$('#packet-block').is(":visible")) {
            return;
        }
        let winBottom = window.pageYOffset + $(window).height();
        if (winBottom < $('#packet-block').offset().top + $('#packet-block').height() - 90) {
            $('#bottom-pay').addClass('stick');
        } else {
            $('#bottom-pay').removeClass('stick');
        }
    });

    $(document).on('click', '.btn-scr', function (e) {
        window.scrollTo({
            top: $('#packet-block').offset().top - 65,
            left: 0,
            behavior: 'smooth',
        });
    });

    setTimeout(function () {
        $(window).scroll()
    }, 2000);

    $(document).on('click', '#use-prepaid', function (e) {
        e.preventDefault();
        startSending();
        let redirect = false;
        $('.invalid-feedback').children('strong').text('');
        $('#payment-form').find('input').removeClass('is-invalid');
        let formData = $('#payment-form').serializeArray();
        $.ajax({
            method: 'POST',
            headers: {Accept: 'application/json'},
            url: options['prepaidUrl'],
            data: formData,
            success: function (response) {
                redirect = response.redirect || false;
                if (response.hidePrepaid) {
                    $('#prepaid-card').hide();
                }

                if (!response.success) {
                    showError();
                } else if (response.redirect) {
                    document.location.href = response.redirect;
                }
            },
            error: function (response) {
                console.log(response)
            },
            complete: function () {
                !redirect && finishSending(300)
            },
        });
    });

    $('.scroll_btn').on('click', function (e) {
        e.preventDefault()
        $('body,html').animate({scrollTop: elms['packet-block'].offset().top- 65});
    })
})
